import React, { useState, useEffect } from 'react'
import NoteTemplateForm from '../note-template-form/NoteTemplateForm'
import NoteTemplateService from '../../../../../services/api/note-template.service'
import APIResponse from '../../../../templates/components/APIResponse';
import DimLoader from '../../../../templates/components/DimLoader';

const NoteTemplateEdit = (props) => {
    const { refresh, initialData } = props;
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)

    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = (data) => {
        setIsLoader(true)
        let reqObj = {
            notes: data.notes,
            notesTemplateId: data.notesTemplateId,
            notesType: 1, // Set NotesType to 1 
            practiceLocationId: data.practiceLocationId,
            shortCode: data.shortCode
        }
        
        // Remove practiceLocationId if undefined/null/empty
        if (reqObj.practiceLocationId === undefined || reqObj.practiceLocationId === null || reqObj.practiceLocationId === '') {
            delete reqObj.practiceLocationId
        }
        
        NoteTemplateService.editNoteTemplate(reqObj)
            .then(response => {
                setApiResponse(response)
                setIsLoader(false)
            })
            .catch(error => {
                setApiResponse(error)
                setIsLoader(false)
            })
    }

    return (
        <>
            {isLoader && <DimLoader loadMessage="Processing" />}
            <NoteTemplateForm 
                submitHandler={submitHandler} 
                initialData={initialData} 
                submitLabel="Update" 
                onClose={() => props.onClose()} 
                refresh={refresh}
                isEdit={true}
            />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default NoteTemplateEdit
